// material-ui
import { MenuItem, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { JSX } from 'react';

import { EHeaderBidder_InventoryType } from '~/src/dash/api/headerbidders/headerbidders_models';
import { TKey, usePublicaTranslation } from '~/src/dash/publicaUI';

const inventoryTypes: { key: EHeaderBidder_InventoryType; tKey: TKey }[] = [
  { key: EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_NONE, tKey: 'None' },
  {
    key: EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_SHARED_NO_BACKFILL,
    tKey: 'SharedWithNoBackfill',
  },
  {
    key: EHeaderBidder_InventoryType.HeaderBidder_INVENTORY_TYPE_SHARED_WITH_BACKFILL,
    tKey: 'SharedWithBackfill',
  },
];

interface IBidderInventoryTypeSelectProps {
  name: string;
  onChange: (bidderTypeKey: React.ChangeEvent) => void;
  value: EHeaderBidder_InventoryType;
  label?: string;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
}

const useStyles = makeStyles({
  input: {
    fontSize: 14,
    borderBottom: '1px solid black',
  },
});

export const BidderInventoryTypeSelect = ({
  onChange,
  value,
  name,
  label,
  fullWidth,
  error,
  helperText,
}: IBidderInventoryTypeSelectProps): JSX.Element => {
  const classes = useStyles();
  const { t } = usePublicaTranslation();
  return (
    <TextField
      name={name}
      select
      label={label}
      fullWidth={fullWidth}
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
      InputProps={{
        disableUnderline: true,
        classes: {
          input: classes.input,
        },
      }}
    >
      {inventoryTypes.map(({ key, tKey }) => {
        return (
          <MenuItem key={key} value={key} style={{ fontSize: 14 }}>
            {t(tKey)}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
